module.exports = __webpack_public_path__ + "static/flags/TD-18d576111ecaae3d31d48b701870220a.gif";